export default __webpack_public_path__ + "static/media/bell-notification.16c247a5.gif";